
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11840',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11840",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.454",
  "dashboard-client-types": "static-1.298",
  "data-fetching-client": "static-1.9555",
  "foundations-components": "static-1.7673",
  "foundations-components-legacy": "static-1.698",
  "foundations-theming": "static-1.4290",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.79",
  "head-dlb": "static-1.4884",
  "hs-test-utils": "static-1.7891",
  "hub-http-shared-msw-handlers": "static-1.9674",
  "hubspot-dlb": "static-2.1806",
  "hubspot-url-utils": "static-1.3957",
  "HubStyleTokens": "static-2.11322",
  "I18n": "static-7.1598",
  "jasmine-runner": "static-1.6349",
  "marketplace-storefront-base": "static-1.11901",
  "quartz": "static-1.6837",
  "react-dlb": "static-1.74",
  "react-rhumb": "static-1.16532",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2742",
  "reporting-testing-lib": "static-1.8826",
  "settings-ui-lib": "static-1.12403",
  "SharedI18nStrings": "static-1.181",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6902",
  "ui-addon-i18n": "static-1.11025",
  "ui-addon-react-router-dom": "static-1.9424",
  "unified-auth": "static-1.316",
  "unified-auth-core-lib": "static-1.597",
  "usage-tracker": "static-1.7215",
  "usage-tracker-core": "static-1.7065",
  "customer-data-property-utils": "static-1.7961",
  "history": "static-4.47",
  "hub-http": "static-1.6098",
  "integrations-lib": "static-1.15693",
  "marketplace-ui-common": "static-1.19209",
  "property-management-iframe": "static-1.12703",
  "quartz-config": "static-1.615",
  "quartz-core": "static-1.6056",
  "quartz-routing": "static-1.267",
  "quick-fetch": "static-1.3813",
  "react": "static-7.182",
  "rpc-client-utils": "static-1.4522",
  "ts-schema": "static-1.3979",
  "ui-universal-auth": "static-1.8802",
  "UIComponents": "static-3.8269",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.416",
  "hs-promise-rejection-tracking": "static-1.5433",
  "PortalIdParser": "static-2.377",
  "raven": "static-3.5768",
  "raven-hubspot": "static-1.6075",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9436",
  "react-redux": "static-7.67",
  "redux": "static-4.16",
  "styled-components": "static-2.85",
  "bend-plugin-trellis-migration": "static-1.3306",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3114",
  "quartz-webpack": "static-1.3061",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.3942",
  "floating-ui": "static-1.53",
  "foundations-assets": "static-1.4719",
  "foundations-theming-specialty": "static-1.2006",
  "framer-motion": "static-1.69",
  "hs-story-utils": "static-1.9307",
  "react-aria": "static-1.63",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5247",
  "react-virtualized": "static-2.96",
  "StyleGuideUI": "static-3.485",
  "tanstack-table": "static-1.52",
  "trellis-assets": "static-1.1447",
  "ui-fonts": "static-1.584",
  "ui-images": "static-2.1124",
  "bend-plugin-foundations-theming": "static-1.2773",
  "foundations-theming-base": "static-1.3275",
  "stylex": "static-1.29",
  "HeadJS": "static-2.732",
  "hs-test-utils-bend-plugin": "static-1.3002",
  "msw": "static-1.39",
  "testing-library": "static-1.149",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.218",
  "moment-timezone": "static-5.80",
  "jasmine": "static-4.4204",
  "ai-components-ui-library": "static-1.8604",
  "ai-rendering-library": "static-1.9609",
  "chirp-fetch": "static-1.1761",
  "connections-embed-lib": "static-1.747",
  "copilot-toolkit": "static-1.10767",
  "laboratory-lib": "static-3.7039",
  "marketplace-embed": "static-1.21710",
  "marketplace-ui-details": "static-1.9105",
  "marketplace-ui-reviews": "static-1.19165",
  "marketplace-ui-tracking": "static-1.13380",
  "sanitize-text": "static-1.8024",
  "ui-addon-video-player": "static-1.8573",
  "usage-tracker-multi": "static-1.5629",
  "usage-tracker-session-replay": "static-1.4901",
  "wootric-nps": "static-1.6863",
  "apollo-link-hub-http": "static-2.4530",
  "immer": "static-1.33",
  "immerable": "static-1.4032",
  "highcharts": "static-8.101",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2420",
  "reporting-data": "static-1.66893",
  "cssUtils": "static-1.764",
  "flux-actions": "static-1.323",
  "HubStyle": "static-2.11630",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10089",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10253",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7205",
  "icons": "static-2.637",
  "marketplace-ui-apps-core": "static-1.17742",
  "storybook-react": "static-1.30",
  "trellis-story-utils": "static-1.4399",
  "foundations-components-test-utils": "static-1.5156",
  "quartz-i18n": "static-1.512",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3610",
  "customer-data-objects": "static-1.7533",
  "property-translator": "static-1.5288",
  "frontend-preferences-client": "static-1.7803",
  "hs-promise-utils": "static-1.5474",
  "hubspot-apollo-client": "static-1.4758",
  "integrations-error-boundary-lib": "static-1.13108",
  "integrations-tracking-lib": "static-1.5472",
  "native-integrations-shared-strings": "static-1.7666",
  "reselect": "static-2.16",
  "sanitize": "static-1.4352",
  "superstore": "static-1.4647",
  "ui-shepherd-react": "static-3.10025",
  "ai-settings-ui-library": "static-1.7681",
  "hub-http-janus": "static-1.816",
  "hubspotter-http": "static-1.4552",
  "immutable-less": "static-1.4532",
  "marketplace-ui-client-types": "static-1.16616",
  "nav-meta": "static-1.29203",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10124",
  "ui-addon-upgrades": "static-9.17793",
  "inbound-db-properties-service-client": "static-1.3745",
  "property-management-common": "static-1.4991",
  "ui-addon-iframeable": "static-1.8928",
  "dispatcher": "static-1.133",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.506",
  "module-federation": "static-1.20",
  "quartz-auth": "static-1.512",
  "quartz-head": "static-1.502",
  "quartz-test": "static-1.512",
  "quartz-tracking": "static-1.216",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.3041",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20711",
  "ContentUtils": "static-1.67899",
  "sassPrefix": "static-1.153",
  "avatar-components": "static-1.2372",
  "customer-data-filters-ui": "static-1.39228",
  "customer-data-objects-ui-components": "static-1.12895",
  "customer-data-reference-ui-components": "static-1.13030",
  "embedded-academy-lib": "static-1.13853",
  "ExportDialog": "static-6.10268",
  "highlight.js": "static-1.76",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40887",
  "reporting-snowflake": "static-1.55511",
  "reporting-ui-components": "static-2.64164",
  "reporting-visualizations": "static-1.58969",
  "ui-addon-teams": "static-1.21370",
  "magpie-lib": "static-1.5473",
  "magpie-types": "static-1.4933",
  "simple-logging-lib": "static-1.2929",
  "navigation-components": "static-1.17566",
  "ai-studio-lib": "static-1.11236",
  "app-governance-lib": "static-1.1148",
  "developer-experience-shared-components": "static-1.10382",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7870",
  "ui-product-approvals": "static-1.27752",
  "ui-tool-access": "static-1.10024",
  "usage-based-billing-components-lib": "static-1.8250",
  "usage-tracker-anonymous": "static-1.5632",
  "usage-tracker-public": "static-1.7026",
  "amplitude-session-replay-browser": "static-1.57",
  "inbound-db-meta-service-client": "static-1.3489",
  "persist-promise": "static-1.3588",
  "reference-resolvers": "static-1.8045",
  "ui-extensibility-client-types": "static-1.3820",
  "hubspot-apollo-cache": "static-1.217",
  "universal-page-editor-lib": "static-1.2883",
  "final-form": "static-1.67",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2416",
  "merchandise-lib": "static-1.261",
  "atom": "static-1.4949",
  "purchase-motions-components": "static-1.5635",
  "salesImages": "static-1.522",
  "batch-promise": "static-1.1431",
  "crm-component-utils": "static-1.38714",
  "crm-properties-common-lib": "static-1.5753",
  "customer-data-properties": "static-1.51075",
  "framework-data-schema-resolvers": "static-1.6753",
  "property-value-citations": "static-1.1689",
  "reference-resolvers-lite": "static-1.7967",
  "navigation-messaging": "static-1.6893",
  "hubspotter-http-shared-msw-handlers": "static-1.9672",
  "cms-field-types": "static-1.4687",
  "content-icons-ui": "static-1.2188",
  "conversations-skeleton-state": "static-1.7128",
  "crm-message-bus": "static-1.42632",
  "customer-data-filters-ui-msw-helpers": "static-1.21663",
  "customer-data-ui-utilities": "static-1.9703",
  "FormUrlGenerator": "static-2.4599",
  "framework-builder-read-service-client": "static-1.3908",
  "framework-data-schema-quick-fetch": "static-1.6658",
  "multi-account-reference-resolvers": "static-1.860",
  "onboarding-tours": "static-1.16377",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13306",
  "academy-common-lib": "static-1.13313",
  "content-assistance-lib": "static-1.7564",
  "dashboard-lib": "static-1.80986",
  "file-manager-components": "static-1.23197",
  "getting-started-shared-tasks": "static-1.18130",
  "hubspot-prosemirror": "static-1.17862",
  "hubspot-prosemirror-plugins": "static-1.17854",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19616",
  "share-with-third-party-component-lib": "static-1.8572",
  "ui-addon-draggable": "static-3.4647",
  "ui-asset-management-lib": "static-1.10837",
  "ui-business-units-lib": "static-1.8916",
  "user-context": "static-1.4979",
  "growth-payments-core": "static-1.24981",
  "reporting-plugins": "static-1.10096",
  "reporting-reports": "static-1.66571",
  "idb-keyval": "static-1.41",
  "reactive-lib": "static-1.603",
  "codemirror": "static-5.92",
  "feedback-loader": "static-1.29046",
  "react-codemirror": "static-1.10503",
  "framework-listing-lib": "static-2.28290",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30366",
  "apps-service-types": "static-1.3756",
  "oauth-service-types": "static-1.4126",
  "onboarding-scopes": "static-1.6342",
  "onboarding-tours-client": "static-1.4591",
  "platform-infra-nav-components": "static-1.7566",
  "subscription-experience-data-types": "static-1.14694",
  "crm-record-cards-service-types": "static-1.3513",
  "location-customization-utils-lib": "static-1.8837",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4377",
  "nav-client-types": "static-1.2236",
  "purchase-motions-api": "static-1.5638",
  "signup-constants": "static-1.18598",
  "signup-ui-url-generator": "static-2.7914",
  "trials-service-types": "static-1.3778",
  "card-properties-lib": "static-1.43781",
  "commerce-subscription-lib": "static-1.36721",
  "crm-actions": "static-1.6191",
  "crm-cards-sdk": "static-1.43188",
  "customer-data-properties-shared-msw-handlers": "static-1.9001",
  "customer-data-tracking": "static-1.6762",
  "hs-resources": "static-1.12",
  "pulse": "static-1.411",
  "calling-global-api": "static-1.64011",
  "calling-internal-common": "static-1.31179",
  "calling-lifecycle-internal": "static-1.65393",
  "calling-lifecycle-messages": "static-1.57687",
  "commerce-products-lib": "static-1.9080",
  "conditional-properties-service-client": "static-1.3697",
  "crm-links": "static-1.6151",
  "external-options-client-types": "static-1.4058",
  "google-libphonenumber": "static-1.35",
  "inbounddb-objects-service-types": "static-1.4122",
  "meetings-icalendar-utils-lib": "static-1.510",
  "multi-currency-client-types": "static-1.3589",
  "object-builder-ui-client": "static-1.48309",
  "pipeline-validation-client-types": "static-1.3863",
  "smart-property-lib": "static-1.6300",
  "tiered-pricing": "static-1.969",
  "ui-addon-form-validation": "static-1.10871",
  "crm-pipelines-api-client-types": "static-1.4042",
  "react-dnd-compat": "static-1.4498",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5240",
  "growth-onboarding-confetti": "static-1.2951",
  "growth-onboarding-next-action-utils": "static-1.1537",
  "onboarding-tours-utils": "static-1.443",
  "ui-shepherd-tracker": "static-1.7406",
  "academy-service-client": "static-1.3559",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.28177",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8262",
  "video-components-external": "static-1.10845",
  "video-data-lib": "static-1.34503",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8436",
  "payment-link-components": "static-1.23168",
  "ui-addon-emoji-picker": "static-1.9766",
  "EmailSignatureEditor": "static-1.24081",
  "viral-links-lib": "static-1.6920",
  "data-token-picker": "static-1.16187",
  "FileManagerLib": "static-1.38837",
  "react-flip-move": "static-1.67",
  "timezone-utils": "static-2.5123",
  "getting-started-shared-tasks-store": "static-1.17248",
  "campaign-roi-lib": "static-1.8549",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-associations": "static-1.7202",
  "customer-data-views-management": "static-1.25164",
  "framework-data-table": "static-2.11605",
  "marketing-platform-lib": "static-1.6727",
  "nudge-client-utils": "static-1.2313",
  "nudge-custom-ui-functions": "static-1.812",
  "app-users-service-client": "static-1.5430",
  "app-users-service-types": "static-1.4838",
  "mini-checkout-client": "static-1.26514",
  "onboarding-utils": "static-1.5229",
  "permissions-shared-i18n-strings-fe": "static-1.1989",
  "ui-coaching-tips-shared-config": "static-1.28162",
  "edison-service-client-types": "static-1.267",
  "eligibility-engine-service-types": "static-1.3059",
  "crm_data": "static-4.91537",
  "customer-data-sidebar": "static-2.45650",
  "enrichment-properties-lib": "static-1.15418",
  "commerce-billing-lib": "static-1.18725",
  "commerce-shared-components-lib": "static-1.18184",
  "commerce-tools-ui-lib": "static-1.10027",
  "crm-fe-perf": "static-1.22782",
  "directed-graph": "static-1.817",
  "event-emitter": "static-1.826",
  "fast-json-patch": "static-1.60",
  "calling-error-reporting": "static-1.31185",
  "shared-worker-versioning": "static-1.10918",
  "calling-usage-tracker": "static-1.6421",
  "voice-sms-access-library": "static-1.510",
  "commerce-permissions": "static-1.643",
  "products-iframe-lib": "static-1.7570",
  "products-ui-components-shared-msw-handlers": "static-1.10056",
  "breeze-intelligence-kit": "static-1.5437",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9757",
  "policy-lib": "static-1.6658",
  "react-tinymce": "static-1.54872",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9820",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53998",
  "tinymce-plugins": "static-1.57112",
  "tinymce-themes": "static-1.55968",
  "growth-onboarding-next-action-components": "static-1.1565",
  "user-context-client": "static-1.4491",
  "growth-onboarding-feedback-components": "static-1.6460",
  "content-media-composition-data-lib": "static-1.11803",
  "content-media-compositions": "static-2.15810",
  "media-bridge-lib": "static-1.18707",
  "commerce-tours-lib": "static-1.5862",
  "growth-onboarding-reliability": "static-1.4966",
  "sales-checkout-service-client": "static-1.3547",
  "draft-convert": "static-2.70",
  "draft-extend": "static-3.72",
  "draft-js": "static-5.75",
  "draft-plugins": "static-2.21454",
  "sales-email-signature-service-client": "static-1.3722",
  "audio-components": "static-1.5727",
  "FileManagerCore": "static-1.38696",
  "FileManagerImages": "static-1.36348",
  "video-components": "static-1.12848",
  "crm-export-dialog": "static-1.6173",
  "crm-index-associations-lib": "static-1.6315",
  "react-beautiful-dnd": "static-1.13",
  "deal-intel-decorators": "static-1.1558",
  "tanstack-virtual": "static-1.27",
  "nudge-custom-function-registry": "static-1.2070",
  "nudge-renderer-utils": "static-1.2389",
  "whisper-core-api": "static-1.6236",
  "InboxConnectUtils": "static-4.14454",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5248",
  "settings-content-modals": "static-1.45707",
  "crm_universal": "static-1.21788",
  "customer-data-email": "static-1.17815",
  "card-payment-highlight-lib": "static-1.36766",
  "card-subscription-highlight-lib": "static-1.39144",
  "commerce-contract-lib": "static-1.11504",
  "invoices-highlight-card-lib": "static-1.54282",
  "orders-highlight-card-lib": "static-1.21096",
  "products-highlight-card-lib": "static-1.17364",
  "quotes-highlight-card-lib": "static-1.71496",
  "crm-source-interpretation-lib": "static-1.5211",
  "utility-belt": "static-1.2419",
  "payments-enrollment-embed-lib": "static-1.22258",
  "stripe-embedded-components": "static-1.7285",
  "customer-data-rte": "static-1.32660",
  "cv-backend-services": "static-1.1531",
  "growth-onboarding-empty-states": "static-1.5488",
  "payments-post-enroll-local-storage-lib": "static-1.4991",
  "qrcode-generator": "static-1.66",
  "quotes-client-types": "static-1.37586",
  "calling-orchestration-schema": "static-1.35287",
  "sales-views-client-types": "static-1.4142",
  "hub-http-contrib": "static-1.2922",
  "interframe": "static-3.4641",
  "tinymce-data": "static-1.40083",
  "ui-addon-sales-email": "static-1.5091",
  "layout-dnd-components": "static-1.12203",
  "layout-dnd-utils": "static-1.11178",
  "ui-brand-identity-lib": "static-1.14519",
  "NamespacedHubStyle": "static-2.8968",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4411",
  "video-embed": "static-1.35337",
  "social-insights-client-types": "static-1.21680",
  "deal-intel-utils": "static-1.1562",
  "checkout-sdk": "static-3.23357",
  "checkout-service-types": "static-1.3725",
  "company-details-components": "static-1.6065",
  "payment-method-components": "static-1.6775",
  "pricing-pages-ui-components": "static-1.13106",
  "quote-checkout-service-types": "static-1.3362",
  "upgrade-catalog-service-types": "static-1.3405",
  "access-control-lib": "static-1.10316",
  "EmailComponents": "static-1.54387",
  "EmailData": "static-1.53064",
  "redux-less": "static-2.9364",
  "sequences-lib": "static-1.7827",
  "ui-gdpr-components": "static-1.10227",
  "products-ui-components": "static-1.39599",
  "quotes-ui-lib": "static-1.80217",
  "accounting-integrations-ui-components": "static-1.6862",
  "invoices-ui-lib": "static-1.54298",
  "commerce-products-api": "static-1.2095",
  "invoices-iframe-lib": "static-1.56356",
  "quotes-modal-lib": "static-1.102174",
  "stripe-connect-js": "static-1.66",
  "draft-content-plugins": "static-1.27928",
  "ContentData": "static-1.67974",
  "layout-data-lib": "static-1.9503",
  "outpost": "static-1.4077",
  "hub-http-rxjs": "static-1.782",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.3808",
  "billing-payments-client-types": "static-1.3867",
  "account-and-billing-fintech-outages": "static-3.18348",
  "pricing-pages-api": "static-1.12971",
  "ContentComponents": "static-2.70855",
  "marketing-contacts-lib": "static-1.9423",
  "marketing-email-service-types": "static-1.1829",
  "messaging-editing-lib": "static-1.45868",
  "messaging-usage-based-billing-components-lib": "static-1.730",
  "automation-ui-source-apps": "static-1.18474",
  "automation-ui-types": "static-1.19392",
  "messaging-types-lib": "static-1.45605",
  "onboarding-settings-client": "static-1.4383",
  "sequences-client-types-lib": "static-1.7684",
  "commerce-tax-lib": "static-1.397",
  "property-description-translator": "static-1.3733",
  "SalesContentIndexUI": "static-3.9039",
  "commerce-analytics-service-client": "static-1.3535",
  "totals-ui-components": "static-1.23216",
  "advanced-menus-core": "static-1.14934",
  "advanced-menus-lib": "static-1.11900",
  "ui-memberships-settings-lib": "static-1.33685",
  "demographics-service-types": "static-1.1527",
  "automation-ui-ubb": "static-1.5308",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7219",
  "data-token-views": "static-1.16168",
  "forms-utils-lib": "static-1.12340",
  "payments-embed-points-lib": "static-1.12778",
  "simple-menus-core": "static-1.14933",
  "simple-menus-lib": "static-1.16450",
  "ui-addon-draggable-compat": "static-2.4133",
  "videoconference-integration-components": "static-1.6642",
  "automation-applications-service-types": "static-1.3399",
  "automation-platform-service-types": "static-1.2544",
  "ContentEditorUI": "static-2.76754",
  "short-messages-app-service-client": "static-1.3867",
  "web-interactives-components": "static-1.13547",
  "web-interactives-data": "static-1.13548",
  "messaging-shared-utils-lib": "static-1.179",
  "messaging-user-info-utils-lib": "static-1.349",
  "email-portal-health-service-types": "static-1.855",
  "FireAlarmUi": "static-1.4408",
  "sales-templates-service-types-lib": "static-1.4066",
  "commerce-totals-service-types": "static-1.3715",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21328",
  "automation-ui-usage-tracking": "static-1.20791",
  "data-studio-ubb": "static-1.2350",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.26651",
  "collaboration-sidebar": "static-1.57387",
  "content-management-data-lib": "static-1.5227",
  "copilot-plugins": "static-1.10740",
  "cta-picker": "static-1.36061",
  "customer-agent-discovery-components-lib": "static-1.2683",
  "editor-components": "static-1.13050",
  "editor-iframe-lib": "static-1.8230",
  "error-messaging-js": "static-1.5069",
  "FormsCommonComponents": "static-1.85509",
  "pictos": "static-7.181",
  "react-transition-group": "static-2.62",
  "redux-request-state": "static-1.10524",
  "SharedLegalStrings": "static-1.1631",
  "smart-content-core": "static-1.42089",
  "smart-content-lib": "static-1.42742",
  "social-composer-lib": "static-1.58472",
  "structured-content-lib": "static-1.24845",
  "theme-previewer-lib": "static-1.52897",
  "tinymce-copilot": "static-1.16066",
  "xray-recommendation-lib": "static-1.7718",
  "automation-ui-routing": "static-1.20749",
  "sql-reporting-client-types": "static-1.5543",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.41865",
  "campaigns-utils-lib": "static-1.3035",
  "reporting-enablement": "static-1.22402",
  "chatspot-widget-iframe": "static-1.20703",
  "collaboration-sidebar-common": "static-1.2184",
  "forms-ai-lib": "static-1.4124",
  "codemirror-dlb": "static-1.58313",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6307",
  "report-customization-components": "static-1.12763",
  "data-quality-ui-library": "static-1.12537",
  "html-to-image": "static-1.51",
  "reporting-insights-lib": "static-1.1331"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11840",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.454",
  "dashboard-client-types": "/dashboard-client-types/static-1.298",
  "data-fetching-client": "/data-fetching-client/static-1.9555",
  "foundations-components": "/foundations-components/static-1.7673",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.698",
  "foundations-theming": "/foundations-theming/static-1.4290",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.79",
  "head-dlb": "/head-dlb/static-1.4884",
  "hs-test-utils": "/hs-test-utils/static-1.7891",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9674",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyleTokens": "/HubStyleTokens/static-2.11322",
  "I18n": "/I18n/static-7.1598",
  "jasmine-runner": "/jasmine-runner/static-1.6349",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11901",
  "quartz": "/quartz/static-1.6837",
  "react-dlb": "/react-dlb/static-1.74",
  "react-rhumb": "/react-rhumb/static-1.16532",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2742",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8826",
  "settings-ui-lib": "/settings-ui-lib/static-1.12403",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.181",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6902",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11025",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9424",
  "unified-auth": "/unified-auth/static-1.316",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.597",
  "usage-tracker": "/usage-tracker/static-1.7215",
  "usage-tracker-core": "/usage-tracker-core/static-1.7065",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7961",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.6098",
  "integrations-lib": "/integrations-lib/static-1.15693",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19209",
  "property-management-iframe": "/property-management-iframe/static-1.12703",
  "quartz-config": "/quartz-config/static-1.615",
  "quartz-core": "/quartz-core/static-1.6056",
  "quartz-routing": "/quartz-routing/static-1.267",
  "quick-fetch": "/quick-fetch/static-1.3813",
  "react": "/react/static-7.182",
  "rpc-client-utils": "/rpc-client-utils/static-1.4522",
  "ts-schema": "/ts-schema/static-1.3979",
  "ui-universal-auth": "/ui-universal-auth/static-1.8802",
  "UIComponents": "/UIComponents/static-3.8269",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.416",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5433",
  "PortalIdParser": "/PortalIdParser/static-2.377",
  "raven": "/raven/static-3.5768",
  "raven-hubspot": "/raven-hubspot/static-1.6075",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9436",
  "react-redux": "/react-redux/static-7.67",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.85",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3306",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3114",
  "quartz-webpack": "/quartz-webpack/static-1.3061",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3942",
  "floating-ui": "/floating-ui/static-1.53",
  "foundations-assets": "/foundations-assets/static-1.4719",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2006",
  "framer-motion": "/framer-motion/static-1.69",
  "hs-story-utils": "/hs-story-utils/static-1.9307",
  "react-aria": "/react-aria/static-1.63",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5247",
  "react-virtualized": "/react-virtualized/static-2.96",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "tanstack-table": "/tanstack-table/static-1.52",
  "trellis-assets": "/trellis-assets/static-1.1447",
  "ui-fonts": "/ui-fonts/static-1.584",
  "ui-images": "/ui-images/static-2.1124",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2773",
  "foundations-theming-base": "/foundations-theming-base/static-1.3275",
  "stylex": "/stylex/static-1.29",
  "HeadJS": "/HeadJS/static-2.732",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3002",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.149",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.218",
  "moment-timezone": "/moment-timezone/static-5.80",
  "jasmine": "/jasmine/static-4.4204",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8604",
  "ai-rendering-library": "/ai-rendering-library/static-1.9609",
  "chirp-fetch": "/chirp-fetch/static-1.1761",
  "connections-embed-lib": "/connections-embed-lib/static-1.747",
  "copilot-toolkit": "/copilot-toolkit/static-1.10767",
  "laboratory-lib": "/laboratory-lib/static-3.7039",
  "marketplace-embed": "/marketplace-embed/static-1.21710",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9105",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19165",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13380",
  "sanitize-text": "/sanitize-text/static-1.8024",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8573",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5629",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4901",
  "wootric-nps": "/wootric-nps/static-1.6863",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4530",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4032",
  "highcharts": "/highcharts/static-8.101",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2420",
  "reporting-data": "/reporting-data/static-1.66893",
  "cssUtils": "/cssUtils/static-1.764",
  "flux-actions": "/flux-actions/static-1.323",
  "HubStyle": "/HubStyle/static-2.11630",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10089",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10253",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7205",
  "icons": "/icons/static-2.637",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17742",
  "storybook-react": "/storybook-react/static-1.30",
  "trellis-story-utils": "/trellis-story-utils/static-1.4399",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5156",
  "quartz-i18n": "/quartz-i18n/static-1.512",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3610",
  "customer-data-objects": "/customer-data-objects/static-1.7533",
  "property-translator": "/property-translator/static-1.5288",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7803",
  "hs-promise-utils": "/hs-promise-utils/static-1.5474",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4758",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13108",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5472",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7666",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4352",
  "superstore": "/superstore/static-1.4647",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10025",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7681",
  "hub-http-janus": "/hub-http-janus/static-1.816",
  "hubspotter-http": "/hubspotter-http/static-1.4552",
  "immutable-less": "/immutable-less/static-1.4532",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16616",
  "nav-meta": "/nav-meta/static-1.29203",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10124",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17793",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3745",
  "property-management-common": "/property-management-common/static-1.4991",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8928",
  "dispatcher": "/dispatcher/static-1.133",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.506",
  "module-federation": "/module-federation/static-1.20",
  "quartz-auth": "/quartz-auth/static-1.512",
  "quartz-head": "/quartz-head/static-1.502",
  "quartz-test": "/quartz-test/static-1.512",
  "quartz-tracking": "/quartz-tracking/static-1.216",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.3041",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20711",
  "ContentUtils": "/ContentUtils/static-1.67899",
  "sassPrefix": "/sassPrefix/static-1.153",
  "avatar-components": "/avatar-components/static-1.2372",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39228",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12895",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13030",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13853",
  "ExportDialog": "/ExportDialog/static-6.10268",
  "highlight.js": "/highlight.js/static-1.76",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40887",
  "reporting-snowflake": "/reporting-snowflake/static-1.55511",
  "reporting-ui-components": "/reporting-ui-components/static-2.64164",
  "reporting-visualizations": "/reporting-visualizations/static-1.58969",
  "ui-addon-teams": "/ui-addon-teams/static-1.21370",
  "magpie-lib": "/magpie-lib/static-1.5473",
  "magpie-types": "/magpie-types/static-1.4933",
  "simple-logging-lib": "/simple-logging-lib/static-1.2929",
  "navigation-components": "/navigation-components/static-1.17566",
  "ai-studio-lib": "/ai-studio-lib/static-1.11236",
  "app-governance-lib": "/app-governance-lib/static-1.1148",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10382",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7870",
  "ui-product-approvals": "/ui-product-approvals/static-1.27752",
  "ui-tool-access": "/ui-tool-access/static-1.10024",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8250",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5632",
  "usage-tracker-public": "/usage-tracker-public/static-1.7026",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.57",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3489",
  "persist-promise": "/persist-promise/static-1.3588",
  "reference-resolvers": "/reference-resolvers/static-1.8045",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3820",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.217",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2883",
  "final-form": "/final-form/static-1.67",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2416",
  "merchandise-lib": "/merchandise-lib/static-1.261",
  "atom": "/atom/static-1.4949",
  "purchase-motions-components": "/purchase-motions-components/static-1.5635",
  "salesImages": "/salesImages/static-1.522",
  "batch-promise": "/batch-promise/static-1.1431",
  "crm-component-utils": "/crm-component-utils/static-1.38714",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5753",
  "customer-data-properties": "/customer-data-properties/static-1.51075",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6753",
  "property-value-citations": "/property-value-citations/static-1.1689",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7967",
  "navigation-messaging": "/navigation-messaging/static-1.6893",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9672",
  "cms-field-types": "/cms-field-types/static-1.4687",
  "content-icons-ui": "/content-icons-ui/static-1.2188",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7128",
  "crm-message-bus": "/crm-message-bus/static-1.42632",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21663",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9703",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4599",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3908",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6658",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.860",
  "onboarding-tours": "/onboarding-tours/static-1.16377",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13306",
  "academy-common-lib": "/academy-common-lib/static-1.13313",
  "content-assistance-lib": "/content-assistance-lib/static-1.7564",
  "dashboard-lib": "/dashboard-lib/static-1.80986",
  "file-manager-components": "/file-manager-components/static-1.23197",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18130",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17862",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17854",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19616",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8572",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4647",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10837",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8916",
  "user-context": "/user-context/static-1.4979",
  "growth-payments-core": "/growth-payments-core/static-1.24981",
  "reporting-plugins": "/reporting-plugins/static-1.10096",
  "reporting-reports": "/reporting-reports/static-1.66571",
  "idb-keyval": "/idb-keyval/static-1.41",
  "reactive-lib": "/reactive-lib/static-1.603",
  "codemirror": "/codemirror/static-5.92",
  "feedback-loader": "/feedback-loader/static-1.29046",
  "react-codemirror": "/react-codemirror/static-1.10503",
  "framework-listing-lib": "/framework-listing-lib/static-2.28290",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30366",
  "apps-service-types": "/apps-service-types/static-1.3756",
  "oauth-service-types": "/oauth-service-types/static-1.4126",
  "onboarding-scopes": "/onboarding-scopes/static-1.6342",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4591",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7566",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14694",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3513",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8837",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4377",
  "nav-client-types": "/nav-client-types/static-1.2236",
  "purchase-motions-api": "/purchase-motions-api/static-1.5638",
  "signup-constants": "/signup-constants/static-1.18598",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7914",
  "trials-service-types": "/trials-service-types/static-1.3778",
  "card-properties-lib": "/card-properties-lib/static-1.43781",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36721",
  "crm-actions": "/crm-actions/static-1.6191",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43188",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9001",
  "customer-data-tracking": "/customer-data-tracking/static-1.6762",
  "hs-resources": "/hs-resources/static-1.12",
  "pulse": "/pulse/static-1.411",
  "calling-global-api": "/calling-global-api/static-1.64011",
  "calling-internal-common": "/calling-internal-common/static-1.31179",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65393",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57687",
  "commerce-products-lib": "/commerce-products-lib/static-1.9080",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3697",
  "crm-links": "/crm-links/static-1.6151",
  "external-options-client-types": "/external-options-client-types/static-1.4058",
  "google-libphonenumber": "/google-libphonenumber/static-1.35",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4122",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.510",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3589",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48309",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3863",
  "smart-property-lib": "/smart-property-lib/static-1.6300",
  "tiered-pricing": "/tiered-pricing/static-1.969",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10871",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4042",
  "react-dnd-compat": "/react-dnd-compat/static-1.4498",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5240",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2951",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1537",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.443",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7406",
  "academy-service-client": "/academy-service-client/static-1.3559",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28177",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8262",
  "video-components-external": "/video-components-external/static-1.10845",
  "video-data-lib": "/video-data-lib/static-1.34503",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8436",
  "payment-link-components": "/payment-link-components/static-1.23168",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9766",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24081",
  "viral-links-lib": "/viral-links-lib/static-1.6920",
  "data-token-picker": "/data-token-picker/static-1.16187",
  "FileManagerLib": "/FileManagerLib/static-1.38837",
  "react-flip-move": "/react-flip-move/static-1.67",
  "timezone-utils": "/timezone-utils/static-2.5123",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17248",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8549",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-associations": "/customer-data-associations/static-1.7202",
  "customer-data-views-management": "/customer-data-views-management/static-1.25164",
  "framework-data-table": "/framework-data-table/static-2.11605",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6727",
  "nudge-client-utils": "/nudge-client-utils/static-1.2313",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.812",
  "app-users-service-client": "/app-users-service-client/static-1.5430",
  "app-users-service-types": "/app-users-service-types/static-1.4838",
  "mini-checkout-client": "/mini-checkout-client/static-1.26514",
  "onboarding-utils": "/onboarding-utils/static-1.5229",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.1989",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28162",
  "edison-service-client-types": "/edison-service-client-types/static-1.267",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3059",
  "crm_data": "/crm_data/static-4.91537",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45650",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15418",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18725",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18184",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10027",
  "crm-fe-perf": "/crm-fe-perf/static-1.22782",
  "directed-graph": "/directed-graph/static-1.817",
  "event-emitter": "/event-emitter/static-1.826",
  "fast-json-patch": "/fast-json-patch/static-1.60",
  "calling-error-reporting": "/calling-error-reporting/static-1.31185",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10918",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6421",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.510",
  "commerce-permissions": "/commerce-permissions/static-1.643",
  "products-iframe-lib": "/products-iframe-lib/static-1.7570",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10056",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5437",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9757",
  "policy-lib": "/policy-lib/static-1.6658",
  "react-tinymce": "/react-tinymce/static-1.54872",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9820",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53998",
  "tinymce-plugins": "/tinymce-plugins/static-1.57112",
  "tinymce-themes": "/tinymce-themes/static-1.55968",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1565",
  "user-context-client": "/user-context-client/static-1.4491",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6460",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11803",
  "content-media-compositions": "/content-media-compositions/static-2.15810",
  "media-bridge-lib": "/media-bridge-lib/static-1.18707",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5862",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4966",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3547",
  "draft-convert": "/draft-convert/static-2.70",
  "draft-extend": "/draft-extend/static-3.72",
  "draft-js": "/draft-js/static-5.75",
  "draft-plugins": "/draft-plugins/static-2.21454",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3722",
  "audio-components": "/audio-components/static-1.5727",
  "FileManagerCore": "/FileManagerCore/static-1.38696",
  "FileManagerImages": "/FileManagerImages/static-1.36348",
  "video-components": "/video-components/static-1.12848",
  "crm-export-dialog": "/crm-export-dialog/static-1.6173",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6315",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1558",
  "tanstack-virtual": "/tanstack-virtual/static-1.27",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2070",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2389",
  "whisper-core-api": "/whisper-core-api/static-1.6236",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14454",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5248",
  "settings-content-modals": "/settings-content-modals/static-1.45707",
  "crm_universal": "/crm_universal/static-1.21788",
  "customer-data-email": "/customer-data-email/static-1.17815",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36766",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39144",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11504",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54282",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21096",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17364",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71496",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5211",
  "utility-belt": "/utility-belt/static-1.2419",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22258",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7285",
  "customer-data-rte": "/customer-data-rte/static-1.32660",
  "cv-backend-services": "/cv-backend-services/static-1.1531",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5488",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4991",
  "qrcode-generator": "/qrcode-generator/static-1.66",
  "quotes-client-types": "/quotes-client-types/static-1.37586",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35287",
  "sales-views-client-types": "/sales-views-client-types/static-1.4142",
  "hub-http-contrib": "/hub-http-contrib/static-1.2922",
  "interframe": "/interframe/static-3.4641",
  "tinymce-data": "/tinymce-data/static-1.40083",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5091",
  "layout-dnd-components": "/layout-dnd-components/static-1.12203",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11178",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14519",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8968",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4411",
  "video-embed": "/video-embed/static-1.35337",
  "social-insights-client-types": "/social-insights-client-types/static-1.21680",
  "deal-intel-utils": "/deal-intel-utils/static-1.1562",
  "checkout-sdk": "/checkout-sdk/static-3.23357",
  "checkout-service-types": "/checkout-service-types/static-1.3725",
  "company-details-components": "/company-details-components/static-1.6065",
  "payment-method-components": "/payment-method-components/static-1.6775",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.13106",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3362",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3405",
  "access-control-lib": "/access-control-lib/static-1.10316",
  "EmailComponents": "/EmailComponents/static-1.54387",
  "EmailData": "/EmailData/static-1.53064",
  "redux-less": "/redux-less/static-2.9364",
  "sequences-lib": "/sequences-lib/static-1.7827",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10227",
  "products-ui-components": "/products-ui-components/static-1.39599",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80217",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6862",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54298",
  "commerce-products-api": "/commerce-products-api/static-1.2095",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56356",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102174",
  "stripe-connect-js": "/stripe-connect-js/static-1.66",
  "draft-content-plugins": "/draft-content-plugins/static-1.27928",
  "ContentData": "/ContentData/static-1.67974",
  "layout-data-lib": "/layout-data-lib/static-1.9503",
  "outpost": "/outpost/static-1.4077",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.782",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.3808",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.3867",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18348",
  "pricing-pages-api": "/pricing-pages-api/static-1.12971",
  "ContentComponents": "/ContentComponents/static-2.70855",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.9423",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1829",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.45868",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.730",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.18474",
  "automation-ui-types": "/automation-ui-types/static-1.19392",
  "messaging-types-lib": "/messaging-types-lib/static-1.45605",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4383",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7684",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.397",
  "property-description-translator": "/property-description-translator/static-1.3733",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9039",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3535",
  "totals-ui-components": "/totals-ui-components/static-1.23216",
  "advanced-menus-core": "/advanced-menus-core/static-1.14934",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11900",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33685",
  "demographics-service-types": "/demographics-service-types/static-1.1527",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5308",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7219",
  "data-token-views": "/data-token-views/static-1.16168",
  "forms-utils-lib": "/forms-utils-lib/static-1.12340",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.12778",
  "simple-menus-core": "/simple-menus-core/static-1.14933",
  "simple-menus-lib": "/simple-menus-lib/static-1.16450",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4133",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6642",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3399",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2544",
  "ContentEditorUI": "/ContentEditorUI/static-2.76754",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3867",
  "web-interactives-components": "/web-interactives-components/static-1.13547",
  "web-interactives-data": "/web-interactives-data/static-1.13548",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.179",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.349",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.855",
  "FireAlarmUi": "/FireAlarmUi/static-1.4408",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4066",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3715",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21328",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.20791",
  "data-studio-ubb": "/data-studio-ubb/static-1.2350",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.26651",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.57387",
  "content-management-data-lib": "/content-management-data-lib/static-1.5227",
  "copilot-plugins": "/copilot-plugins/static-1.10740",
  "cta-picker": "/cta-picker/static-1.36061",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.2683",
  "editor-components": "/editor-components/static-1.13050",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8230",
  "error-messaging-js": "/error-messaging-js/static-1.5069",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85509",
  "pictos": "/pictos/static-7.181",
  "react-transition-group": "/react-transition-group/static-2.62",
  "redux-request-state": "/redux-request-state/static-1.10524",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1631",
  "smart-content-core": "/smart-content-core/static-1.42089",
  "smart-content-lib": "/smart-content-lib/static-1.42742",
  "social-composer-lib": "/social-composer-lib/static-1.58472",
  "structured-content-lib": "/structured-content-lib/static-1.24845",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.52897",
  "tinymce-copilot": "/tinymce-copilot/static-1.16066",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7718",
  "automation-ui-routing": "/automation-ui-routing/static-1.20749",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5543",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.41865",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3035",
  "reporting-enablement": "/reporting-enablement/static-1.22402",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.20703",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2184",
  "forms-ai-lib": "/forms-ai-lib/static-1.4124",
  "codemirror-dlb": "/codemirror-dlb/static-1.58313",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6307",
  "report-customization-components": "/report-customization-components/static-1.12763",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12537",
  "html-to-image": "/html-to-image/static-1.51",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1331"
}
};
